<template>
  <v-app>
    <div class="page-container">
      <div class="navbar-container">
        <Navbar :title="$t('text_payment')" :show-language-button="false" :show-back-button="true" />
      </div>
      <v-container class="main-container pt-0">
        <v-card elevation="2" class="rounded-lg mb-8 mt-4">
          <div class="d-flex align-start justify-start">
            <v-avatar class="ma-3 rounded-lg" size="90" tile>
              <v-img :src="storeData?.logo" style="border-radius: 50px"></v-img>
            </v-avatar>
            <div class="d-flex flex-column">
              <v-card-title class="pb-0 font-weight-bold">{{
                storeData?.name
              }}</v-card-title>
              <v-card-text class="pb-1 pt-0">
                {{ formatCurrency(totalReservationPrice, true) }}
              </v-card-text>
              <v-card-text class="pb-0 pt-0">
                <v-chip label small>
                  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" class="mr-2"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M12 13.6668H2C1.196 13.6668 0 13.1342 0 11.6668V10.3335V8.3335V4.3335V2.3335C0 0.866163 1.196 0.333496 2 0.333496H10.6667C11.402 0.333496 12 0.931496 12 1.66683V9.00016V10.3335V11.0002H11.3333H10.6667H2.008C1.7 11.0082 1.33333 11.1302 1.33333 11.6668C1.33333 12.2035 1.7 12.3255 2.008 12.3335H12V13.6668ZM1.33333 2.3335V4.3335V8.3335V9.66683H10.6667V9.00016V1.66683H2C1.7 1.67483 1.33333 1.79683 1.33333 2.3335ZM9.33333 3.00016H3.33333V4.3335H9.33333V3.00016Z"
                      fill="#272727" />
                  </svg>
                  {{ $t('reservation_place') }}
                </v-chip>
              </v-card-text>
            </div>
          </div>
        </v-card>

        <v-row no-gutters class="mb-4 align-center">
          <v-col cols="2">
            <div class="image-payment mr-2">
              <v-img :src="getPayment?.image" style="max-width: 70px; border-radius: 8px"></v-img>
            </div>
          </v-col>
          <v-col cols="10">
            <div class="d-flex flex-column">
              <span class="font-weight-bold body-1">{{ getPayment?.name }}</span>
              <span v-if="getQueryPaymentCode !== 'DANA'" class="text-caption grey--text">{{ $t('text_input_phone_number') }}</span>
            </div>
          </v-col>
        </v-row>

        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
          <v-form>
            <template v-if="getQueryPaymentCode !== 'DANA'">
              <PhoneNumber v-model="phone" label="No. Handphone" />
            </template>

            <div class="description-payment mt-4">
              <v-alert text>
                <p class="p1"><b>Syarat dan Ketentuan</b></p>
                <ol class="ol1">
                  <li class="li2">Sudah terinstall aplikasi {{ getPayment?.code === 'ShopeePay' ? 'Shopee' :
                    getPayment?.name }} dan memiliki akun {{ getPayment?.name }} yang aktif.</li>
                  <li class="li2">Saldo {{ getPayment?.name }} mencukupi total yang harus dibayar.</li>
                  <li class="li2">Pembayaran Anda akan diteruskan ke Aplikasi {{ getPayment?.code === 'ShopeePay' ?
                    'Shopee' : getPayment?.name }} untuk menyelesaikan pembayaran.</li>
                  <li class="li2">Pembayaran berhasil jika sukses melakukan pembayaran di aplikasi {{ getPayment?.code ===
                    'ShopeePay' ? 'Shopee' : getPayment?.name }}.</li>
                </ol>
              </v-alert>
            </div>

            <div class="btn-nav-footer">
              <v-btn color="success" :elevation="0" class="font-weight-bold" style="width: 100%;" :disabled="getLoadingAxiosState || loading_payment" @click="handleSubmit()">
                {{ $t('text_next') }}
              </v-btn>
            </div>
          </v-form>
        </ValidationObserver>

      </v-container>
    </div>
  </v-app>
</template>

<script>
import Navbar from "@/components/Layouts/Navbar.vue";
import { mapGetters } from "vuex";
import PhoneNumber from "@/components/PhoneNumber.vue";
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
import { orderPayment } from "@/api/payment";
import { formatCurrency } from "@/utils/currencyUtils";
import { setQueryParam } from '@/utils/customQuery'
import { getSelfOrder } from "@/api/payment";
export default {
  name: "Ewallet",
  components: {
    Navbar,
    PhoneNumber,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      phone: "",
      loading_payment: false,
    };
  },
  computed: {
    storeData() {
      return this.$store.getters.getStoreData;
    },
    placeReservation() {
      return this.$store.getters.orderData?.place_reservation ?? [];
    },
    getQueryPage() {
      return this.$store.getters.getQueryRouter.find(item => item.key === 'page')?.value
    },
    getQueryPaymentId() {
      return this.$store.getters.getQueryRouter.find(item => item.key === 'payment_id')?.value
    },
    getQueryPaymentCode() {
      return this.$store.getters.getQueryRouter.find(item => item.key === 'code')?.value
    },
    ...mapGetters(["orderData", "getPayment", "getStoreData", "dataCartReservation", "totalReservationPrice","getLoadingAxiosState"]),
  },
  mounted() {
    this.handleCheckUpdate();
  },
  methods: {
    formatCurrency,
    async handleCheckUpdate() {
      if (this.orderData?.id) {
        this.loading_payment = true
        try {
          const { data } = await getSelfOrder(this.orderData.id).then(
            (res) => res.data
          );
          this.$store.dispatch("create_order", data);
          if (data.is_paid) {
            this.$store.dispatch("removeAllReservation");
            this.$store.dispatch("set_router_data", { name: 'order-detail', params: { order_id: data.id } });
            setQueryParam('page', 'order-detail')
            setQueryParam('order_id', data.id)
          }
        } catch (e) {
          console.log('error', e);
          this.$store.state.show_error = true;
          this.$store.state.error_message = e.string;
          this.$store.state.error_type = e.statusCode;
        } finally {
          this.$store.state.loading_axios = false;
          this.loading_payment = false
        }
      }
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        const url = new URL(window.location.href);
        const paymentBody = {
          remark: "PLACE_RESERVATION",
          item: this.dataCartReservation.map((item) => {
            return {
              layout_item_id: item.id,
              reserve_date: item.reservation_date.date,
              reserve_time: item.reserve_time,
              notes: item.item_place_reservation.notes,
            };
          }),
          payment: {
            payment_mode_id: this.getQueryPaymentId,
            bank_code: this.getQueryPaymentCode,
            phone: this.phone,
            redirect_url: `${url.origin}/reservation-place?page=order-detail`,
          },
          url_id: this.$store.state.store_data?.url_id,
        };

        // console.log(JSON.stringify(paymentBody, null, 2));
        // console.log("validated", this.phone);
        // this.$store.dispatch("create_order", orderEWallet.data)
        // this.$store.dispatch("set_router_data", { name: 'order-detail', params: { order_id: orderEWallet.data.id } });

        this.loading_payment = true

        try {
          const paymentData = await orderPayment(paymentBody, {
            url_id: this.$store.state.store_data?.url_id,
          });
          const data = paymentData.data.data
          this.$store.dispatch("create_order", data);
          this.$store.dispatch("removeAllReservation");
          if (data.payment_log) {
            if (data.payment_log.checkout_url) {
              window.location = data.payment_log.checkout_url;
              // this.$store.dispatch("set_router_data", { name: 'order-detail', params: { order_id: data.id } });
              // setQueryParam('page', 'order-detail')
              // setQueryParam('order_id', data.id)
            }
          }
        } catch (e) {
          console.log('error', e);
          if (e.statusCode === 401) {
            this.$store.dispatch("fetchToken");
          } else {
            this.$store.state.show_error = true;
            this.$store.state.error_message = e.string;
            this.$store.state.error_type = e.statusCode;
          }
        } finally {
          this.$store.state.loading_axios = false;
          this.loading_payment = false
        }
      }
    },
  },
};
</script>

<style>
.main-container {
  gap: 0 !important;
}
</style>
